import { type IEntitiesStore } from 'entities/EntitiesExport'

export const sendEnhancePromptLogEvent = (
  entities: IEntitiesStore,
  data: { agent_id?: number; agentType: string }
) => {
  entities.eventLogStore.logEvent(
    'Enhance_Prompt_Used',
    {
      event_id: 'enhance_prompt_used',
      userId: entities.usersStore.user_owner_id,
      agencyId: entities.organizationStore.agency_id,
      ...data,
    },
    { groupId: entities.organizationStore.id }
  )
}
